import React from 'react';
import PropTypes from 'prop-types';

import Controls from './controls';
import Message from './message';
import Modal from 'components/modal';

export default function CreateListing({ deal, onClose, onCreate }) {
  return <React.Fragment>
    <Modal.Body>
      <Message deal={deal} />
    </Modal.Body>

    <Modal.Footer>
      <Controls deal={deal} onClose={onClose} onCreate={onCreate} />
    </Modal.Footer>
  </React.Fragment>;
}

CreateListing.propTypes = {
  deal: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
};
